import {Component, computed, effect, model} from '@angular/core';
import {Drawer} from 'primeng/drawer';
import {phoneBannerVisibilitySignal} from '../../signal/common/phone-banner-visibility.signal';
import {Button} from 'primeng/button';
import {PrimeTemplate} from 'primeng/api';
import {MicrosoftClarityService} from '../../analytics/microsoft/microsoft-clarity.service';
import {MicrosoftClarityEvents} from '../../analytics/microsoft/types/microsoft-clarity-events.enum';
import {MicrosoftClaritySessionBumper} from '../../analytics/microsoft/types/microsoft-clarity-session-bumper.enum';
import {routingMetadata} from '../../signal/common/routing-matadata.signal';
import {PixelService} from '../../analytics/meta/pixel.service';
import {GoogleAnalyticsService} from '../../analytics/google/google-analytics.service';
import {AnalyticsEventCategory, AnalyticsEventName} from '../../enum/gtm-cookie-consent.enum';
import {AvailablePhoneBannerEvent, PixelEventName} from '../../analytics/meta/types/pixel.types';
import {consentBannerVisibilitySignal} from '../../signal/common/consent-banner-visibility.signal';

@Component({
  selector: 'app-phone-banner',
  imports: [
    Drawer,
    PrimeTemplate,
    Button
  ],
  templateUrl: './phone-banner.component.html',
  styleUrl: './phone-banner.component.scss',
})
export class PhoneBannerComponent {

  protected readonly isVisible = model(false);
  protected phone = computed(() => routingMetadata().contact?.phone[0] || undefined);

  constructor(
    private readonly microsoftClarityService: MicrosoftClarityService,
    private readonly googleAnalyticsService: GoogleAnalyticsService,
    private readonly pixelService: PixelService
  ) {
    effect(() => {
      if (this.phone() && !consentBannerVisibilitySignal()) this.isVisible.set(phoneBannerVisibilitySignal())
    });
    effect(() => phoneBannerVisibilitySignal.set(this.isVisible()));
  }

  protected onVisibleChange($visibilityEvent: boolean) {

    if ($visibilityEvent) {
      this.microsoftClarityService.trackEvent(MicrosoftClarityEvents.PhoneBannerShown);

      this.googleAnalyticsService.trackEvent({
          event: AnalyticsEventName.PhoneBannerShown,
          eventCategory: AnalyticsEventCategory.PhoneBanner
        }
      );

      this.pixelService.trackEvent(PixelEventName.PhoneBanner, {
        event: AvailablePhoneBannerEvent.SHOW
      });
    } else {
      this.microsoftClarityService.trackEvent(MicrosoftClarityEvents.PhoneBannerClose);

      this.googleAnalyticsService.trackEvent({
          event: AnalyticsEventName.PhoneBannerClose,
          eventCategory: AnalyticsEventCategory.PhoneBanner
        }
      );

      this.pixelService.trackEvent(PixelEventName.PhoneBanner, {
        event: AvailablePhoneBannerEvent.CLOSE
      });
    }

    this.microsoftClarityService.upgradeSession(MicrosoftClaritySessionBumper.PhoneBanner);
  }

  protected onClose() {
    this.isVisible.set(false);
    this.microsoftClarityService.trackEvent(MicrosoftClarityEvents.PhoneBannerReject);
    this.microsoftClarityService.upgradeSession(MicrosoftClaritySessionBumper.PhoneBanner);

    this.googleAnalyticsService.trackEvent({
        event: AnalyticsEventName.PhoneBannerReject,
        eventCategory: AnalyticsEventCategory.PhoneBanner
      }
    );

    this.pixelService.trackEvent(PixelEventName.PhoneBanner, {
      event: AvailablePhoneBannerEvent.REJECT
    });
  }

  protected onCall() {
    this.microsoftClarityService.trackEvent(MicrosoftClarityEvents.PhoneBannerClick);
    this.microsoftClarityService.upgradeSession(MicrosoftClaritySessionBumper.PhoneBanner);

    this.googleAnalyticsService.trackEvent({
        event: AnalyticsEventName.PhoneBannerClick,
        eventCategory: AnalyticsEventCategory.PhoneBanner
      }
    );

    this.pixelService.trackEvent(PixelEventName.PhoneBanner, {
      event: AvailablePhoneBannerEvent.CLICK
    });
  }
}
